var _path, _path2, _path3, _circle, _circle2, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconRenovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7509 27.7845L35.7381 24.5099C35.7323 24.2196 35.6137 23.9429 35.4073 23.7386C35.2009 23.5344 34.9231 23.4186 34.6327 23.4158L13.0985 23.4974L13.1339 33.5165L17.1442 33.5003C17.8417 33.5056 18.5368 33.4181 19.2113 33.2403L34.9374 28.8584C35.1715 28.7924 35.3776 28.6518 35.5244 28.4579C35.6712 28.2641 35.7507 28.0276 35.7509 27.7845Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.143 33.5099L13.0985 23.4974L6.02045 23.5072C5.72608 23.5094 5.44452 23.6279 5.23707 23.8368C5.02962 24.0456 4.91307 24.328 4.9128 24.6224L4.95342 34.0788C4.95336 34.2259 4.98238 34.3716 5.03879 34.5074C5.09521 34.6432 5.17792 34.7666 5.28216 34.8704C5.38641 34.9741 5.51013 35.0563 5.64622 35.1121C5.78232 35.1679 5.9281 35.1962 6.07518 35.1955L10.454 35.1738C10.8312 35.1717 11.1966 35.0423 11.4911 34.8066L13.143 33.5099Z",
    stroke: "white",
    strokeWidth: 1.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46607 32.6947L7.43232 26.0204L10.6031 26.0071L10.648 31.6523L9.38526 32.687L7.46607 32.6947Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8059,
    cy: 25.9877,
    r: 0.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8059,
    cy: 27.7738,
    r: 0.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.725,
    y: -0.725,
    width: 32.3,
    height: 9.8,
    rx: 1.775,
    transform: "matrix(1 0 0 -1 3.16772 14.55)",
    stroke: "white",
    strokeWidth: 1.45
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 1.875,
    y2: -0.625,
    transform: "matrix(0 1 1 0 9.41821 13.2499)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 4.375,
    y2: -0.625,
    transform: "matrix(4.37113e-08 1 1 -4.37113e-08 9.41821 10.7499)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 3.125,
    y2: -0.625,
    transform: "matrix(0 1 1 0 13.1677 12)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 4.375,
    y2: -0.625,
    transform: "matrix(0 1 1 0 16.9185 10.7499)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 3.125,
    y2: -0.625,
    transform: "matrix(0 1 1 0 20.6677 12)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 4.375,
    y2: -0.625,
    transform: "matrix(0 1 1 0 24.4185 10.7499)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 3.125,
    y2: -0.625,
    transform: "matrix(0 1 1 0 28.1677 12)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.625,
    y1: -0.625,
    x2: 4.375,
    y2: -0.625,
    transform: "matrix(0 1 1 0 31.9185 10.7499)",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconRenovation);
export default __webpack_public_path__ + "static/media/Home-Icon-Renovation.728053a0c636f0c9862c3c2c2a8448e7.svg";
export { ForwardRef as ReactComponent };